// extracted by mini-css-extract-plugin
module.exports = {"ServiceManagement":"ServiceManagement_ServiceManagement__1-JQN"};